var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIconSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.0625C4.97005 0.0625 4.01302 0.322266 3.12891 0.841797C2.27214 1.3431 1.5931 2.02214 1.0918 2.87891C0.572266 3.76302 0.3125 4.72005 0.3125 5.75C0.3125 6.77995 0.572266 7.73698 1.0918 8.62109C1.5931 9.47786 2.27214 10.1569 3.12891 10.6582C4.01302 11.1777 4.97005 11.4375 6 11.4375C7.02995 11.4375 7.98698 11.1777 8.87109 10.6582C9.72786 10.1569 10.4069 9.47786 10.9082 8.62109C11.4277 7.73698 11.6875 6.77995 11.6875 5.75C11.6875 4.72005 11.4277 3.76302 10.9082 2.87891C10.4069 2.02214 9.72786 1.3431 8.87109 0.841797C7.98698 0.322266 7.02995 0.0625 6 0.0625ZM6 0.9375C6.875 0.9375 7.6862 1.15625 8.43359 1.59375C9.15365 2.02214 9.72786 2.59635 10.1562 3.31641C10.5938 4.0638 10.8125 4.875 10.8125 5.75C10.8125 6.625 10.5938 7.4362 10.1562 8.18359C9.72786 8.90365 9.15365 9.47786 8.43359 9.90625C7.6862 10.3438 6.875 10.5625 6 10.5625C5.125 10.5625 4.3138 10.3438 3.56641 9.90625C2.84635 9.47786 2.27214 8.90365 1.84375 8.18359C1.40625 7.4362 1.1875 6.625 1.1875 5.75C1.1875 4.875 1.40625 4.0638 1.84375 3.31641C2.27214 2.59635 2.84635 2.02214 3.56641 1.59375C4.3138 1.15625 5.125 0.9375 6 0.9375ZM3.375 5.3125V6.1875H8.625V5.3125H3.375Z",
    fill: "#089BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIconSm);
export default __webpack_public_path__ + "static/media/remove-icon-sm.c9be174b5b8703d19f068afc36aaca03.svg";
export { ForwardRef as ReactComponent };